
export function AddItem(itemData)
{
    return(
        { 
            type: 'add_cart',
            payload: itemData,
        }
    )
}